export const TRIAL_BOOKING_URL = 'https://timerex.net/s/luuumos/5a0b9962';
